export const DEFAULT_IMPACT = {
    label: '',
    value: '',
};

export const DEFAULT_CAUSE = {
    label: '',
    value: '',
};
